module.exports = __webpack_public_path__ + "Chat_Suite.ffd813b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/portal_icons/Chat_Suite.png
// module id = 715
// module chunks = 0